export default "__VITE_ASSET__5EIBi7Df__"